import Container from '@/components/structure/Container'
import RichText from '@/components/content/common/RichText'

import { Icon } from '@/icons/Icon'
import { cn } from '@/lib/utils'
import type { Block } from '@/types/app'
import type { Page } from '@/payload-types'

type ListTemplate = Extract<NonNullable<Page['layout']>[number], { blockType: 'listTemplate' }>
type ListBlockProps = Pick<ListTemplate, 'lists'> & { editor?: boolean }

export default function ListBlock({ lists, editor }: ListBlockProps) {
  if (lists?.length) {
    const content = (
      <>
        {lists.map((block, index) => (
          <div
            key={`block-${index}`}
            className={cn(
              'flex flex-col gap-base p-base',
              !editor && 'border-b border-dark-100 last:border-0 md:p-12',
            )}
          >
            <h1 className="title">{block.headline}</h1>
            <ul className="flex flex-col gap-5">
              {block.list?.map((item, index) => (
                <li className="flex items-start gap-2" key={`listItem-${index}`}>
                  <Icon
                    name={item.icon as string}
                    size={26}
                    className="mt-[5px] text-primary-500"
                  />
                  <div className="flex flex-col gap-1">
                    <h3>{item.title}</h3>
                    <RichText content={item.content?.root.children as Block[]} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </>
    )

    if (editor) {
      return content
    }

    return <Container className="mx-auto w-full max-w-content px-2.5 md:px-5">{content}</Container>
  }
}
